import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';

import OneClickButton from '../../../../components/form/button';
import Form from '../../../../components/form/form';
import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';
import FormatHelpers from '../../../../helpers/format';
import ROUTES from '../../../../config/routes';
import {
  listFractionalPackagingFromStockBalance,
  printFractionalPackagingFromStockBalance,
} from '../../../../app/store/actions/labels';
import { getUserPrinterOptions } from '../../../../app/store/actions/printers';

import ConfirmModal from './confirmModal';
import FilteringModal from './filteringModal';

const MAX_LABELS = 999;

class LabelFractionalPackagingFromStockBalance extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE1371' /* Etiquetas */) },
      { value: I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */), active: true },
    ];

    this.state = {
      listCombinations: [],
      combinationCount: 0,
      showFilterModal: false,
      showConfirmModal: false,
      showPrinterDialog: false,
      tableFilter: null,
      columnSide: 'both',
      printQuantityOnLabel: 'no',
      printerOptions: [],
      printerSelected: null,
      pendingPrintParams: null,
      defaultPageSize: 10,
      defaultSorted: [{ id: 'addressCode', desc: false }],
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE267' /* Endereço */),
        accessor: 'addressCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      }, {
        Header: I18n.t('BEE1897' /* Descrição */),
        accessor: 'productName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE182' /* Depósito */),
        accessor: 'depositCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE428' /* Lote */),
        accessor: 'lotNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
      }, {
        Header: I18n.t('BEE434' /* Data de Validade */),
        accessor: 'expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Cell: (row) => (
          <span>{row.value ? moment(row.value).format('L') : ''}</span>
        ),
      }, {
        Header: I18n.t('BEE530' /* Disponível */),
        accessor: 'available',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
      },
    ];
  }

  async componentDidMount() {
    await this.getUserPrinterOptions();
  }

  getUserPrinterOptions = async () => {
    const Info = await this.props.getUserPrinterOptions();
    const { userPrinter, printerOptions } = Info;
    const { printerSelected } = this.state;

    let printer = userPrinter;
    if (printerSelected !== null && printerSelected !== userPrinter) {
      printer = printerSelected;
    }

    this.setState({
      printerOptions,
      printerSelected: printer,
    });
  };

  setValue = (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  closeFilters = () => {
    this.setState({ showFilterModal: false });
  };

  closeConfirm = () => {
    this.setState({ showConfirmModal: false });
  };

  hidePrinterDialog = () => {
    this.setState({
      showPrinterDialog: false,
      pendingPrintParams: null,
    });
  };

  onApplyFilters = async (tableFilter, columnSide) => {
    try {
      const result = await this.props.listFractionalPackagingFromStockBalance(
        tableFilter,
        columnSide,
        'asc',
      );

      let listCombinations = [];
      if (Array.isArray(result)) {
        listCombinations = result;
      } else if (result && Array.isArray(result.data)) {
        listCombinations = result.data;
      }
      const combinationCount = listCombinations.length;

      this.setState({
        tableFilter,
        columnSide,
        listCombinations,
        combinationCount,
        showFilterModal: false,
      });
    } catch (err) {
      this.setState({
        listCombinations: [],
        combinationCount: 0,
      });

      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        addNotification(
          'danger',
          I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
          I18n.t('BEE1969' /* Erro ao buscar dados */),
          'top-right',
        );
      }
    }
  };

  openPrintFlow = () => {
    const { combinationCount } = this.state;

    if (!combinationCount) {
      addNotification(
        'danger',
        I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
        I18n.t('BEE4829' /* Nenhuma combinação encontrada com os filtros informados. */),
        'top-right',
      );
      return;
    }

    if (combinationCount > MAX_LABELS) {
      addNotification(
        'danger',
        I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
        I18n.t(
          'BEE4832',
          { 0: combinationCount },
        ),
        'top-right',
      );
      return;
    }

    this.setState({ showConfirmModal: true });
  };

  onConfirmPrint = (params) => {
    const { printerOptions, printerSelected } = this.state;

    if (printerOptions.length === 0 && printerSelected === null) {
      addNotification(
        'danger',
        I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
        I18n.t('BEE1415' /* Usuário não possui impressora relacionada */),
        'top-right',
      );
      return;
    }

    this.setState({
      showConfirmModal: false,
      pendingPrintParams: params,
    });

    if (printerOptions && printerOptions.length > 1) {
      this.setState({ showPrinterDialog: true });
    } else {
      this.printOut(params);
    }
  };

  printOut = async (params) => {
    const printParams = params || this.state.pendingPrintParams;

    if (!printParams) {
      return;
    }

    this.setState({ showPrinterDialog: false });

    try {
      const {
        tableFilter,
        columnSide,
        printQuantityOnLabel,
        printerOptions,
        printerSelected,
      } = this.state;

      const selected = (printerSelected === null) ? printerOptions[0].value : printerSelected;

      const result = await this.props.printFractionalPackagingFromStockBalance(
        selected,
        tableFilter,
        columnSide,
        printParams.printOrder,
        printParams.copiesPerCombination,
        printQuantityOnLabel === 'yes',
      );

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
          I18n.t('BEE1441' /* Erro ao tentar imprimir */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
          I18n.t('BEE1427' /* Etiquetas enviadas para impressora ! */),
          'top-right',
        );
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification(
          'danger',
          I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
          I18n.t('BEE1441' /* Erro ao tentar imprimir */),
          'top-right',
        );
      }
    } finally {
      this.setState({ pendingPrintParams: null });
    }
  };

  render() {
    const {
      listCombinations,
      combinationCount,
      showFilterModal,
      showConfirmModal,
      showPrinterDialog,
      printerOptions,
      printerSelected,
      printQuantityOnLabel,
      defaultPageSize,
      defaultSorted,
    } = this.state;

    return (
      <>
        <Table
          downloadCSV
          buttonFilter={{
            actionButton: () => { this.setState({ showFilterModal: true }); },
          }}
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */)}
          wikiHelp={ROUTES.FRACTIONAL_PACKAGING_LABEL_FROM_STOCK_BALANCE_HELP}
          downButtonPosition
          actionButtons={(
            <div className="ml-auto d-flex align-items-center flex-wrap">
              <div className="d-flex align-items-center mr-3 mb-2 mb-sm-0 print-quantity-on-label-radios">
                <span className="mr-2 mt-2 text-nowrap">
                  {`${I18n.t('BEE4825' /* Deseja imprimir a quantidade na etiqueta? */)} :`}
                </span>
                <div className="radio radio-css radio-inline">
                  <input
                    type="radio"
                    id="printQuantityOnLabelNo"
                    checked={printQuantityOnLabel === 'no'}
                    onChange={() => this.setValue('printQuantityOnLabel', 'no')}
                  />
                  <label htmlFor="printQuantityOnLabelNo">
                    {I18n.t('BEE173' /* Não */)}
                  </label>
                </div>
                <div className="radio radio-css radio-inline">
                  <input
                    type="radio"
                    id="printQuantityOnLabelYes"
                    checked={printQuantityOnLabel === 'yes'}
                    onChange={() => this.setValue('printQuantityOnLabel', 'yes')}
                  />
                  <label htmlFor="printQuantityOnLabelYes">
                    {I18n.t('BEE172' /* Sim */)}
                  </label>
                </div>
              </div>
              <style>
                {`
                        .print-quantity-on-label-radios .radio.radio-css label:before {
                          background: #fff;
                          border: 1px solid #fff;
                        }
                        .print-quantity-on-label-radios .radio.radio-css input:checked + label:before {
                          background: #fff;
                          border-color: #fff;
                        }
                        .print-quantity-on-label-radios .radio.radio-css input:checked + label:after {
                          background: #2d353c;
                        }
                      `}
              </style>
              <strong className="mr-3 mb-2 mt-2 mb-sm-0 text-nowrap">
                {I18n.t('BEE4824' /* Combinações encontradas */)}
                {': '}
                {combinationCount}
              </strong>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={this.openPrintFlow}
              >
                {I18n.t('BEE1270' /* Imprimir */)}
              </OneClickButton>
            </div>
          )}
          filterable
          data={listCombinations}
          columns={this.tableColumns}
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        <FilteringModal
          showFilterModal={showFilterModal}
          closeFilters={this.closeFilters}
          onApplyFilters={this.onApplyFilters}
        />
        <ConfirmModal
          showConfirmModal={showConfirmModal}
          closeConfirm={this.closeConfirm}
          combinationCount={combinationCount}
          onConfirm={this.onConfirmPrint}
        />
        {(showPrinterDialog && (
          <SweetAlert
            confirmBtnText={I18n.t('BEE436' /* Selecionar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE1324' /* Selecionar Impressora */)}
            onConfirm={() => this.printOut()}
            onCancel={() => this.hidePrinterDialog()}
          >
            <div className="mt-4">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createSelect(
                    printerSelected,
                    'printerSelected',
                    I18n.t('BEE328' /* Impressora */),
                    printerOptions,
                    '',
                    '',
                    12,
                    true,
                  ),
                ])}
              />
            </div>
          </SweetAlert>
        ))}
      </>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getUserPrinterOptions: () => dispatch(getUserPrinterOptions()),
  listFractionalPackagingFromStockBalance: (filters, columnSide, printOrder) => dispatch(
    listFractionalPackagingFromStockBalance(filters, columnSide, printOrder),
  ),
  printFractionalPackagingFromStockBalance: (
    printerCode,
    filters,
    columnSide,
    printOrder,
    copiesPerCombination,
    printQuantityOnLabel,
  ) => dispatch(
    printFractionalPackagingFromStockBalance(
      printerCode,
      filters,
      columnSide,
      printOrder,
      copiesPerCombination,
      printQuantityOnLabel,
    ),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LabelFractionalPackagingFromStockBalance));
